// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2V6tg","header":"ClearentDisclaimer_header__3EhUV","inner":"ClearentDisclaimer_inner__3cTXv"};